<template>
  <aside class="page-sidebar-mobile-container">
    <div
      class="page-sidebar-mobile-overlay"
      :class="{ active: show }"
      @click="setMenu(false)"
    ></div>

    <div
      class="page-sidebar-mobile d-flex flex-column d-lg-none"
      :class="{ active: show }"
    >
      <div class="header d-flex align-items-center">
        <b-avatar
          class="avatar"
          src="https://assets.admin.wize.pe/images/dropdown-user-avatar.svg"
        >
        </b-avatar>
        <div class="d-flex flex-column pl-3" v-if="user">
          <span class="user-name">{{ user.name }}</span>
          <span class="email d-inline-block mt-1">{{ user.email }}</span>
        </div>
      </div>

      <div class="grid mt-2 px-2" v-if="isAffiliate">
        <router-link
          :to="{ name: 'AffiliateDashboard' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'AffiliateDashboard' }"
        >
          <span class="menu-icon"><i class="ri-dashboard-line"></i></span>
          Dashboard
        </router-link>

        <router-link
          :to="{ name: 'AffiliateRides' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'AffiliateRides' }"
        >
          <span class="menu-icon"><i class="ri-car-line"></i></span>
          Mis Viajes
        </router-link>

        <router-link
          :to="{ name: 'AffiliatePassword' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'AffiliatePassword' }"
        >
          <span class="menu-icon"><i class="ri-lock-line"></i></span>
          Contrasena
        </router-link>
      </div>

      <div class="grid mt-2 px-2" v-else>
        <!-- Viajes -->
        <router-link
          :to="{ name: 'viajes-ride-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name == 'viajes-ride-list' }"
        >
          <span class="menu-icon">
            <i class="ri-car-line"></i>
          </span>
          Viajes
        </router-link>

        <!-- Tarifas -->
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isTarifasRoute }"
          @click="setSelection('tarifas')"
        >
          <span class="menu-icon">
            <i class="ri-price-tag-3-line"></i>
          </span>
          Tarifas
        </button>

        <!-- Pasajeros -->
        <router-link
          :to="{ name: 'config-passenger-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name == 'config-passenger-list' }"
        >
          <span class="menu-icon">
            <i class="ri-user-line"></i>
          </span>
          Pasajeros
        </router-link>

        <!-- Afiliados -->
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isAfiliadosRoute }"
          @click="setSelection('afiliados')"
        >
          <span class="menu-icon">
            <i class="ri-user-line"></i>
          </span>
          Afiliados
        </button>

        <!-- Travelbot -->
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isTravelbotRoute }"
          @click="setSelection('travelbot')"
        >
          <span class="menu-icon">
            <i class="ri-robot-2-line"></i>
          </span>
          Travelbot
        </button>

        <!-- Mantenimiento -->
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isConfigRoute }"
          @click="setSelection('config')"
        >
          <span class="menu-icon">
            <i class="ri-edit-line"></i>
          </span>
          Mantenimiento
        </button>

        <!-- Auditoría -->
        <router-link
          :to="{ name: 'audit-log' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name == 'audit-log' }"
        >
          <span class="menu-icon">
            <i class="ri-file-list-3-line"></i>
          </span>
          Auditoría
        </router-link>
      </div>

      <div class="menu-list-container">
        <ul class="menu-list list-unstyled" v-if="selection">
          <li v-for="item in getMenuItems" :key="item.text">
            <router-link
              :to="item.route"
              exact-active-class="active"
              class="menu-subitem text-decoration-none"
            >
              <BulletIcon class="fill-white mr-3" />{{ item.text }}
            </router-link>
          </li>
        </ul>
      </div>

      <button
        type="button"
        class="menu-option d-flex align-items-center"
        @click="logout()"
      >
        <i class="ri-logout-box-r-line"></i>
        <span class="sidebar-item-text">Cerrar sesión</span>
      </button>

      <div
        class="menu-option classic version d-flex justify-content-between align-items-center"
      >
        <span class="text">V{{ version }} {{ year }}</span>
        <p class="my-0">
          Forjado por <a href="https://wize.pe" target="_blank">Wize</a>
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { BulletIcon } from "wize-admin";

export default {
  name: "PageSidebarMobile",
  components: { BulletIcon },
  props: {
    show: Boolean,
  },
  data() {
    return {
      version: process.env.PACKAGE_VERSION,
      year: new Date().getFullYear(),
      selection: "",
      menuList: [
        {
          key: "tarifas",
          list: [
            { route: { name: "tarifas-tarifario" }, text: "Tarifario" },
            { route: { name: "tarifas-base-price-list" }, text: "Precios Base" },
            { route: { name: "tarifas-price-rules" }, text: "Reglas de Cálculo" },
          ],
        },
        {
          key: "afiliados",
          list: [
            { route: { name: "config-affiliate-list" }, text: "Lista" },
            { route: { name: "config-category-list" }, text: "Categorías" },
          ],
        },
        {
          key: "travelbot",
          list: [
            { route: { name: "travelbot-black-list" }, text: "Black List" },
          ],
        },
        {
          key: "config",
          list: [
            { route: { name: "config-user-list" }, text: "Usuarios" },
            { route: { name: "config-vehicle-type-list" }, text: "Tipo de Vehículos" },
            { route: { name: "config-vehicle-list" }, text: "Vehículos" },
            { route: { name: "config-driver-list" }, text: "Conductores" },
            { route: { name: "config-coupon-list" }, text: "Cupones" },
          ],
        },
      ],
    };
  },
  mounted() {
    if (this.isTarifasRoute) {
      this.setSelection("tarifas");
    } else if (this.isAfiliadosRoute) {
      this.setSelection("afiliados");
    } else if (this.isTravelbotRoute) {
      this.setSelection("travelbot");
    } else if (this.isConfigRoute) {
      this.setSelection("config");
    }
  },
  watch: {
    "$route.name": function () {
      if (screen.width < 992) {
        this.setMenu(false);
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isMenuOpen: "app/isMenuOpen",
      isAffiliate: "auth/isAffiliate",
    }),
    getMenuItems() {
      let item = this.menuList.find((item) => item.key == this.selection);
      return item ? item.list : [];
    },
    isTarifasRoute() {
      let routes = ["tarifas"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
    isAfiliadosRoute() {
      let routes = ["afiliados", "config-affiliate", "config-category"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        this.selection === "afiliados"
      );
    },
    isTravelbotRoute() {
      let routes = ["travelbot"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
    isConfigRoute() {
      let routes = ["config-user", "config-vehicle", "config-driver", "config-coupon"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        this.selection === "config"
      );
    },
  },
  methods: {
    ...mapMutations({
      setMenu: "app/setMenu",
    }),
    setSelection(key) {
      this.selection = key;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style lang="stylus">
@import "../../styles/components/layout/page-sidebar-mobile.styl"
</style>
